import { Link as LinkS } from 'react-scroll';
import styled from 'styled-components';

export const Nav = styled.nav`
  background: 'transparent';
  height: 80px;
  margin-top: -80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  top: 0;
  z-index: 10;

  @media screen and (max-width: 960px) {
    transition: 0.8s all ease;
  }
`;

export const NavbarContainer = styled.div`
  display: flex;
  justify-content: space-between;
  height: 80px;
  z-index: 1;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
`;

export const NavLogo = styled.h1`
  color: ${({ scrollNav }) => (scrollNav ? '#fff' : '#5d795d')};
  justify-self: flex-start;
  font-size: 1.5rem;
  display: flex;
  align-items: center;
  margin-left: 25px;
  font-weight: bold;
  text-decoration: none;

  @media screen and (max-width: 960px) {
    color: #fff;
  }

  @media screen and (max-width: 480px) {
    font-size: 1.3rem;
  }

  @media screen and (max-width: 400px) {
    font-size: 1.1rem;
  }
`;

export const MobileIcon = styled.div`
  display: none;

  @media screen and (max-width: 980px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin-right: -22px;

  @media screen and (max-width: 980px) {
    display: none;
  }
`;

export const NavItem = styled.li`
  height: 80px;
`;

export const NavBtn = styled.nav`
  display: flex;
  align-items: center;

  @media screen and (max-width: 980px) {
    display: none;
  }
`;

export const NavLinksS = styled(LinkS)`
  color: ${({ scrollNav }) => (scrollNav ? '#fff' : '#5d795d')};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &:hover {
    color: #8c68e8;
    transition: all 0.2s ease-in-out;
  }

    &:active {
    color: #05c865;
  }
`; 

export const NavLinks = styled.a`
  color: ${({ scrollNav }) => (scrollNav ? '#fff' : '#5d795d')};
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;

  &:hover {
    color: #8c68e8;
    transition: all 0.2s ease-in-out;
  }

  &:active {
    color: #05c865;
  }
`;

export const NavBtnConnect = styled.button`
  border-radius: 50px;
  background: transparent;
  white-space: nowrap;
  padding: 10px 45px;
  color: ${({ scrollNav }) => (scrollNav ? '#fff' : '#5d795d')};
  font-size: 16px;
  outline: none;
  border: solid 3px;
  borderColor: ${({ scrollNav }) => (scrollNav ? '#fff' : '#5d795d')};
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #9069f8;
    color: #fff;
    border: solid 3px #fff;
  }

  &:active {
    background: #05c865;
    color: #fff;
    border: solid 3px #fff;
  }
`;

export const NavBtnConnected = styled.div`
  border-radius: 50px;
  background: #05c865;
  white-space: nowrap;
  padding: 10px 45px;
  color: #fff;
  font-size: 16px;
  outline: none;
  border: solid 3px #fff;
  text-decoration: none;
`

export const NavMusic = styled.audio`
  left: 5px;
  color: transparent;
`
